var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chrome-dashboard',{attrs:{"enabled":_vm.fetched}},[(_vm.fetched)?_c('list-box',{class:( _obj = {}, _obj[_vm.$style.listWrapper] = true, _obj[_vm.$style.isEmpty] = _vm.list.length === 0, _obj ),attrs:{"title":"Vendors","enable-search":true,"is-loading":_vm.isSearchLoading,"list":_vm.list,"page-number":_vm.page.number,"page-size":_vm.page.size,"record-count":_vm.page.recordCount,"route":function (data) { return ({
      name: 'vendor',
      params: {
        vendorId: data.id,
      },
    }); }},on:{"delete":_vm.askDelete,"page":function($event){_vm.load($event); _vm.fetchOnRouteChange = false;}},scopedSlots:_vm._u([{key:"innerHead",fn:function(){return [(_vm.list.length)?_c('router-link',{staticClass:"button-bar",attrs:{"tag":"button","title":"Add new vendor","to":{
          name: 'vendor',
          params: {
            vendorId: 'create',
          },
        }}},[_vm._v(" ㊉ Add ")]):_vm._e()]},proxy:true},{key:"noData",fn:function(){return [_c('p',{class:_vm.$style.emptyRecords},[_vm._v(" Adding vendors helps you understand what products and services are being provided to you, allowing you to compare vendors on critical metrics such such as price, availability and performance. ")]),_c('router-link',{staticClass:"large primary",attrs:{"tag":"button","to":{
          name: 'vendor',
          params: {
            vendorId: 'create',
          },
        }}},[_vm._v(" Add first vendor ")])]},proxy:true},{key:"row",fn:function(ref){
        var row = ref.row;
return [_vm._v(" "+_vm._s(row.data.name)+" ")]}}],null,false,2407096866)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }